
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface TermsOfServiceModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const TermsOfServiceModal = ({ open, onOpenChange }: TermsOfServiceModalProps) => {
  const { t } = useTranslation();

  const prohibitedItems = t('terms.section3.items', { returnObjects: true }) as string[];
  const suspensionItems = t('terms.section4.items', { returnObjects: true }) as string[];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">{t('terms.title')}</DialogTitle>
          <DialogDescription>
            {t('terms.lastUpdated')}
          </DialogDescription>
        </DialogHeader>

        <div className="text-left space-y-4 mt-4">
          <p>{t('terms.intro')}</p>

          <h3 className="text-lg font-semibold">{t('terms.section1.title')}</h3>
          <p>{t('terms.section1.body')}</p>

          <h3 className="text-lg font-semibold">{t('terms.section2.title')}</h3>
          <p>{t('terms.section2.body')}</p>

          <h3 className="text-lg font-semibold">{t('terms.section3.title')}</h3>
          <p>{t('terms.section3.body')}</p>
          <ul className="list-disc pl-6">
            {Array.isArray(prohibitedItems) && prohibitedItems.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <h3 className="text-lg font-semibold">{t('terms.section4.title')}</h3>
          <p>{t('terms.section4.body')}</p>
          <ul className="list-disc pl-6">
            {Array.isArray(suspensionItems) && suspensionItems.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <h3 className="text-lg font-semibold">{t('terms.section5.title')}</h3>
          <p>{t('terms.section5.body')}</p>

          <h3 className="text-lg font-semibold">{t('terms.section6.title')}</h3>
          <p>{t('terms.section6.body')}</p>

          <h3 className="text-lg font-semibold">{t('terms.section7.title')}</h3>
          <p>{t('terms.section7.body')}</p>

          <h3 className="text-lg font-semibold">{t('terms.section8.title')}</h3>
          <p>{t('terms.section8.body')}</p>

          <h3 className="text-lg font-semibold">{t('terms.section9.title')}</h3>
          <p>{t('terms.section9.body')}</p>

          <div className="mt-6">
            <div>{t('terms.contact.company')}</div>
            <div>{t('terms.contact.address')}</div>
            <div>{t('terms.contact.email')}</div>
            <div>{t('terms.contact.phone')}</div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
